import { formatDate } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CustomDatePipe } from 'src/app/pipes/custom-date.pipe';
import { CommonService } from 'src/app/services/common.service';
import { messages } from 'src/app/resources/messages';

@Component({
  selector: 'date-range',
  templateUrl: './date-range.component.html',
  styleUrls: ['./date-range.component.scss'],
  providers: [CustomDatePipe]
})
export class DateRangeComponent implements OnInit {
  @Input() isRequired: boolean = true;
  @Input() submitted!: string;
  @Input() intervalDays: number=1;
  @Input() parentForm!: FormGroup;
  @Output() selectedFromDate = new EventEmitter<string>();
  @Output() selectedToDate = new EventEmitter<string>();
  @Output() defaultDates = new EventEmitter<string[]>();

  public fromDefaultDate!: string;
  public toDefaultDate!: string;
  public retentionPeriod!: any;
  public msg = messages;

  constructor(private customDate: CustomDatePipe,
    private commonService: CommonService) { }

  ngOnInit(): void {
    this.retentionPeriod = this.commonService.getRetentionPeriodDateRange();
    this.setDefaultDates()
  }

  private setDefaultDates() {
    let currentDate = new Date();
    this.toDefaultDate = formatDate(currentDate, 'dd MMM yyyy', 'en-US');
    this.fromDefaultDate = formatDate(currentDate.setDate(currentDate.getDate() - this.intervalDays), 'dd MMM yyyy', 'en-US')
    this.emitDefaultDates();
  }

  public emitDefaultDates(){
    this.defaultDates.emit([this.fromDefaultDate, this.toDefaultDate])
  }

  setFromDate($event: any) {
    const dateVal = this.customDate.transform($event);
    this.fromDefaultDate = '';
    this.selectedFromDate.emit(dateVal!);
  }

  setToDate($event: any) {
    const dateVal = this.customDate.transform($event);
    this.toDefaultDate = '';
    this.selectedToDate.emit(dateVal!);
  }

  get dateRangeError() {
    if (this.parentForm.getError('dateRange')) {
      return this.parentForm.getError('errorMsg');
    }
    return false;
  }

  public reset() {
    this.setDefaultDates();
  }

  setCustomDisplayDates(fromDate: string, toDate: string) {
    this.fromDefaultDate = formatDate(fromDate, 'dd MMM yyyy', 'en-US')
    this.toDefaultDate = formatDate(toDate, 'dd MMM yyyy', 'en-US');
    this.emitDefaultDates();
  }
}
